import React, { useMemo } from 'react';
import { Grid, Skeleton } from '@mui/material';

interface Props {
	categoryCount?: number;
	rowsPerCategory?: number;
}

let keySequence = 0;
const generateKeys = (count: number) =>
	Array.from({ length: count }, () => `skeleton-key-${keySequence++}`);

// Category-shaped placeholder shown while a template apply is in progress (or
// the LoF/CoF categories are otherwise loading). Mirrors the InfoCard layout
// used by `Category` — a title row plus a few component rows — so the page
// doesn't jump once real data arrives.
export const SetupCategoriesSkeleton = ({
	categoryCount = 2,
	rowsPerCategory = 3,
}: Props) => {
	const categoryKeys = useMemo(
		() => generateKeys(categoryCount),
		[categoryCount],
	);
	const rowKeys = useMemo(
		() => generateKeys(rowsPerCategory),
		[rowsPerCategory],
	);

	return (
		<Grid
			container
			data-testid="setup-categories-skeleton"
			data-cy="setup-categories-skeleton">
			{categoryKeys.map(categoryKey => (
				<Grid
					item
					xs={12}
					key={categoryKey}
					style={{ paddingBottom: '12px' }}>
					<Grid
						container
						alignItems="center"
						justifyContent="space-between"
						style={{ padding: '16px 20px' }}>
						<Skeleton variant="text" width={160} height={28} />
						<Skeleton variant="rounded" width={110} height={32} />
					</Grid>
					{rowKeys.map(rowKey => (
						<Grid
							container
							alignItems="center"
							key={rowKey}
							style={{ padding: '10px 20px' }}>
							<Grid item xs={2}>
								<Skeleton variant="text" width={80} />
							</Grid>
							<Grid item xs={10}>
								<Skeleton
									variant="rounded"
									width="100%"
									height={24}
								/>
							</Grid>
						</Grid>
					))}
				</Grid>
			))}
		</Grid>
	);
};

export default SetupCategoriesSkeleton;
